export default "__VITE_ASSET__596f3adb__"